<template>
    <AxRoadListItem
        :icon="picture || require('@/assets/icons/driver.png')"
        :icon-color="iconColor"
        :primary-text="item.name"
        :to="to"
        has-alert
        class="axroad-list-item"
    >
        <template #secondaryText>
            <span class="axroad-list-item__warning">
                {{
                    item.warnings.length
                        ? $tc('warningsCount', item.warnings.length)
                        : $t('no_warnings')
                }}
            </span>
        </template>
    </AxRoadListItem>
</template>

<script>
import AxRoadHelpers from '@/mixins/AxRoadHelpers'
import AxRoadListItem from '@/components/ax-road/AxRoadListItem'
import { mapGetters } from 'vuex'

export default {
    name: 'AxRoadWarningsListItem',
    components: {
        AxRoadListItem,
    },
    mixins: [AxRoadHelpers],
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters('tracker', ['assetTypesById']),
        truckAssetType() {
            if (this.item.asset_details) {
                return this.assetTypesById[this.item.asset_details?.asset_type]
            }

            return null
        },
        truckIconUrl() {
            if (!this.truckAssetType) {
                return ''
            }

            return (
                this.truckAssetType.marker_ax_road?.url ||
                this.truckAssetType.marker.url
            )
        },
        picture() {
            return this.item.type === 'driver'
                ? this.item.picture ||
                      this.item.external_picture ||
                      require('@/assets/icons/driver.png')
                : this.truckIconUrl
        },
        iconColor() {
            return this.item.type === 'truck'
                ? this.getAxRoadAssetColor(this.item)
                : this.getAxRoadDriverColor(this.item)
        },
        to() {
            return {
                name:
                    this.item.type === 'driver'
                        ? 'axRoadDriverWarnings'
                        : 'axRoadTruckWarnings',
                params: {
                    id:
                        this.item.type === 'driver'
                            ? this.item.driver_id
                            : this.item.id,
                },
                query: this.$route.query,
            }
        },
    },
}
</script>

<i18n>
{
    "en": {
        "no_warnings": "No warnings",
        "warningsCount": "{n} Warning | {n} Warnings"
    },
    "de": {
        "no_warnings": "Keine Warnungen",
        "warningsCount": "{n} Warnung | {n} Warnungen"
    },
    "fr": {
        "no_warnings": "Aucun avertissement",
        "warningsCount": "{n} Avertissement | {n} Avertissements"
    },
    "it": {
        "no_warnings": "Nessun avviso",
        "warningsCount": "{n} Avviso | {n} Avvisi"
    }
}
</i18n>

<style lang="scss">
.axroad-list-item {
    &__warning {
        color: $color-danger;
        font-weight: 500;
    }
}
</style>
